import React from 'react'
import { Column, WidgetCell, Button } from '@sencha/ext-modern'

import { reconfigButton } from 'tyan/public/utility'
import { getBindedProps } from './utilities'

const render = (column, that, forViewModel, checkGridData) => {
	// console.log('debug column:', column)
	const { _button, key, title, width, bind, tooltip, icon, ui, disabled, hidden, text, handler, style, ...rest } = reconfigButton(column)
	return <Column width={width} align="center" key={key} text={title} {...rest} menuDisabled>
		<WidgetCell height='40px'>
			<Button text={_button}
				{...getBindedProps({ bind, icon, ui, disabled, tooltip, hidden, text, style, handler }, that, key, forViewModel, checkGridData)}
			// handler={me => handler && handler(that, me.up('widgetcell').getRecord().data, me.up('widgetcell').getRecord())}
			>
			</Button>
		</WidgetCell>
	</Column>
}

export default render